export default __webpack_public_path__ + "static/media/product-image-card-3.048abcac.jpg";